/** Two-letter initials for avatar chips (no allocation beyond the string). */
export const userInitialsFromEmail = (email: string): string => {
  const local = email.split("@")[0] ?? email;
  const cleaned = local.replace(/[^a-zA-Z0-9]/gu, "");
  if (cleaned.length >= 2) {
    return cleaned.slice(0, 2).toUpperCase();
  }
  if (local.length >= 2) {
    return local.slice(0, 2).toUpperCase();
  }
  return local.length === 1 ? local.toUpperCase() : "?";
};
